import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import lunr from 'lunr'
import { Link } from 'gatsby'
import Img from "gatsby-image"
import styled from "styled-components"
import emptyIcon from "../images/search-empty.svg"
import imagePlaceholder from "../images/image-placeholder.png"
import chunk from "lodash/chunk"
import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"
import Helmet from 'react-helmet';
import * as queryString from "query-string";
import { useLocation } from '@reach/router';
import { result } from 'lodash'

const SearchResults = styled.div`
    .search-form {
        padding-top: 20px;
        padding-bottom: 20px;
        &__input {
            width: 320px;
            border-radius: 6px 0 0 6px;
            border-right: none;
            border-color: #999;
            outline: 0;
            font-size: 1rem;
            @media screen and (max-width: 767px) {
                border-right: 1px solid #999;
                border-radius: 6px;
                margin-bottom: 1rem;
                width: 100%;
            }
        }
        &__button {
            width: 220px;
            border-radius: 0 6px 6px 0;
            border: none;
            @media screen and (max-width: 767px) {
                border-radius: 6px;
                width: 100%;
            }
        }
        &__msg {
            min-height: 24px;
        }
        
    }
    .post-list{
        padding-left: 0;
    }
    .post-item {
        border-bottom: 1px dashed #ccc;
        list-style: none;
        &__content {
            display: flex;
            align-items: start;
            @media screen and (max-width: 767px) {
                flex-direction: column;
            }
        }
        &__texts {
            width: calc(100% -  250px);
            .link {
                font-size: 14px;
                color: #666;
                text-decoration: underline;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            h2 {
                padding-top: 12px;
                font-size: 1.5rem;
                padding-bottom: 0;
            }
            @media screen and (max-width: 767px) {
                width: 100%;
            }
        }
        &__img {
            width: 220px;
            min-width: 220px;
            min-height: 120px;
            overflow: hidden;
            margin-right: 20px;
            margin-top: 4px;
            @media screen and (max-width: 767px) {
                margin-right: 0;
                width: 100%;
                .image-placeholder{
                    width: 100%;
                }
            }
        }
        &__summary {
            padding-bottom: 8px;
            // min-height: 52px;
            * {
                font-size: 16px !important;
                font-weight: normal !important;
                font-family: inherit !important;
                font-style: normal !important;
                line-height: 130% !important;
                padding: 0 !important;
                margin: 0 !important;
                width: auto !important;
                height: auto !important;
                text-align: left !important;
                display: inline !important;
                &:before, &:after {
                    padding: 0 !important;
                    margin: 0 !important;
                }
            }
            br, img, iframe {
                display: none !important;
            }
            sub, sup {
                font-size: 0.8em !important;
            }
        }
        a {
            display: block;
            margin: 28px 0;
            text-decoration: none;
        }
        .gatsby-image-wrapper {
            border-radius: 6px;
            border: 1px solid #f4f4f4;
        }
        .image-placeholder {
            border-radius: 6px;
        }
    }
    .search-results {
        min-height: 460px;
        padding: 3rem 0;
        &.empty{
            background-color: #f4f4f4;
            border-bottom: 1px solid #ccc;
            text-align: center;
            padding-top: 90px;
        }
        &__empty {
            color: #888;
            padding-bottom: 30px;
            img {
                width: 220px;
            }
        }
        &__load-more {
            padding: 1.4em 0;
        }
        &__banner {
            padding: 3.6rem 0;
        }
    }
    .lds-ring {
        display: block;
        position: relative;
        width: 80px;
        height: 80px;
        margin: 0 auto;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: rgba(255, 255, 255, 0.5) transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        nimation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .loading-wrapper{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.4);
        z-index: 9;
        top: 0;
        left: 0;
        padding-top: 220px;
    }
`

const minCharacters = 3;
const contentCharLimit = 190;
const defaultArticleViewLimit = 12;

const getIndex = (posts) => {
  return lunr(function () {
    this.ref('id')
    this.field('title')
    this.field('content')

    for (let i in posts) {
		this.add({
            id: posts[i].node.id,
            title: posts[i].node.title,
            content: posts[i].node.content
        })
	}
  })
}

export default () => {
    const data = useStaticQuery(graphql`{
        allWordpressPost {
            edges {
            node {
                id
                link
                content
                title
                type
                path
                slug
                categories {
                    slug
                    name
                }
                author {
                    name
                    slug
                }
                featured_media {
                    source_url
                    media_details {
                        width
                        height
                    }
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 220, maxHeight: 144, quality: 100) {
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            }
            }
        }
    }`)

    const {
    allWordpressPost: { edges: posts }
    } = data;

    const [query, setQuery] = useState('');
    //  Default the posts list
    const [results, setResults] = useState(posts);
    const [idx, setIdx] = useState(null);
    const [postsToShow, setPostsToShow] = useState(defaultArticleViewLimit);
    const [isQuoted, setIsQuoted] = useState(false);
    const location = useLocation();
    const { keywords } = queryString.parse(location.search);
    const [isLoading, setIsLoading] = useState(true);

    const searchPost = (query, idx) => {
        const result = idx.search(query)
        return result.map((item) => {
            return posts.find((post) => item.ref === post.node.id)
        })
    }
    const sendTracking = (query)=>{
        window._waEvents.push("trackEvent", {
            events: ['intsearch'],
            intSearchTerm: query,
        });
    }
    const doSearch = (idx, query, minCharacters) => {
        setIsLoading(true);
        if (idx && query && query.length >= minCharacters) {
            const searchRes = searchPost(`${query}`, idx);
            setResults(searchRes);
            setPostsToShow(defaultArticleViewLimit);
            setIsQuoted(true);
            sendTracking(query);
        }
        setTimeout(()=>{
            setIsLoading(false);
        }, 500)
    }

    const metaData = {
        title: 'Health Insurance Resource Center Article Search - eHealth Insurance',
        metaDescription: `Confused about health insurance coverage? Get informed about different health insurance plans & Obamacare from eHealth's Resource Center today.`,
    }
    useEffect(() => {
        const idx = getIndex(posts);
        setIdx(idx);
        if (keywords) {
            setQuery(keywords);
            doSearch(idx, keywords, minCharacters);
        }
        setTimeout(()=>{
            setIsLoading(false);
        }, 500)
    }, []);
    useEffect(() => {
        let pageData = {
            page: {
                section: "general",
                name: "article search",
                language: "english",
            },
            sysEnv: {
                siteGroup: "rc",
            }
        }
        if (results.length === 0) {
            pageData = {
                events: ['intsearchnoresults'],
                page: {
                    section: "general",
                    name: "article search",
                    language: "english",
                },
                sysEnv: {
                    siteGroup: "rc",
                }
            }
        }
        if (!isLoading) {
            window._waEvents.push("pageView", pageData)
        }
    }, [isLoading]);

    return (
    <SearchResults>
        <SEO {...metaData}/>
        <Helmet>
            <link rel="canonical" href={`https://www.${process.env.GATSBY_SUBDOMAIN || ""}ehealthinsurance.com/resources/search`}/>
        </Helmet>
        <div className="ehi-header--spacer"></div>
        <section className="bg-blue-light text-blue-text search-results__banner">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-lg-9 text-center">
                        <h1 className="h1">Article search</h1>
                        <div>Enter the keywords to find article about health insurance at eHealth.</div>
                        <div className="search-form">
                            <input
                                id="email"
                                className="w-full my-lg mx-auto search-form__input"
                                type="text"
                                onChange={e => {
                                    setQuery(e.target.value.replace(/[|&!*#;$=%^_/?@":~<>()+,]/g, ""));
                                    setIsQuoted(false);
                                }}
                                value={query}
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        doSearch(idx, query, minCharacters)
                                    }
                                }}
                                autoComplete='off'
                                placeholder="Search..."
                            />
                            <input
                                type="button"
                                className="button-primary search-form__button"
                                value="Search"
                                onClick={e => {
                                    doSearch(idx, query, minCharacters)
                                }}
                            />
                        </div>
                        <div className="search-form__msg">
                        {query.length > 0 && query.length < minCharacters && `Please type at least ${minCharacters} characters`}
                        {isQuoted && results.length > 0 && query.length >= minCharacters && `Showing ${results.length} results for "${query}"`}
                        {isQuoted && results.length <= 0 && query.length >= minCharacters && `No results found for "${query}"`}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className={`search-results ${results.length <= 0 ? 'empty' : ''}`}>
          <div className="container">
            {chunk(results.slice(0, postsToShow), postsToShow).map(
                (chunk, i) => (
                    <ul className="post-list" key={`chunk-${i}`}>
                        {chunk.map(({ node: post }) => {
                            const content = post.content;
                            const contentCapped = `${content?.substring(0, contentCharLimit)}${content?.length > contentCharLimit ? '...' : ''}`
                            return (
                            <li className="post-item" key={`post-${post.id}`}>
                                <Link to={`/${post.categories[0].slug}/${post.slug}`}>
                                    <div className="post-item__content">
                                        <div className="post-item__img">
                                            {post.featured_media && post.featured_media.localFile ? (
                                                <Img
                                                    fluid={post.featured_media.localFile.childImageSharp.fluid}
                                                    objectFit="cover"
                                                    objectPosition="50% 50%"
                                                    alt=""
                                                />
                                            ) : (
                                                <img className="image-placeholder" src={imagePlaceholder} />
                                            )}
                                        </div>
                                        <div className="post-item__texts">
                                            <h2>
                                                {post.title}
                                            </h2>
                                            <div
                                                className="post-item__summary"
                                                dangerouslySetInnerHTML={{
                                                    __html: contentCapped
                                                }}
                                            />
                                            <div className="link" title={`https://www.ehealthinsurance.com${post.path}`}>https://www.ehealthinsurance.com{post.path}</div>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        )})}
                    </ul>
                )
            )}
            {postsToShow < results.length && (
                <div className="search-results__load-more text-center">
                    <button
                        className="button-tertiary"
                        onClick={() => {
                            setPostsToShow(postsToShow + 12)
                        }}
                    >
                        Load More
                    </button>
                </div>
            )}
            {results.length === 0 && (
                <div className="search-results__empty">
                    <img src={emptyIcon} />
                    <div><b>No results found</b></div>
                    <div>Try adjusting your search or filter to find what you're looking for.</div>
                </div>
            )}
          </div>
      </section>
      {isLoading && (
        <div className="loading-wrapper">
            <div className="container__row">
                <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
      )}
      
    </SearchResults>
  )

}